/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { AnyAction } from 'redux';
import { Log } from '../../../core/logging/Log';
import { setErrorOSDAction, setIsErrorOSDActiveAction } from './osd.actions';
import { SET_ERROR_OSD, SET_IS_ERROR_OSD_ACTIVE } from './osd.types';

const initialState: {
    isErrorOSDActive: boolean;
    errorCode: string;
    errorMessage: string;
    errorPriority: number;
} = {
    isErrorOSDActive: false,
    errorCode: '',
    errorMessage: '',
    errorPriority: 0,
};

const TAG: string = 'OSD';

const osdReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_IS_ERROR_OSD_ACTIVE:
            return {
                ...state,
                isErrorOSDActive: payload.isErrorOSDActive,
            };
        case SET_ERROR_OSD:
            return {
                ...state,
                errorCode: payload.errorCode,
                errorMessage: payload.errorMessage,
                errorPriority: payload.errorPriority,
            };
        default:
            return state;
    }
};

/**
 * Error priority will range from 0 to 999.
 * 0 - lowest priority
 * 999 - highest priority
 */

export const hideErrorOSD = () => (dispatch: Function, getState: Function) => {
    const { isErrorOSDActive } = getState().errorOsd;

    if (isErrorOSDActive) {
        Diagnostics.info(TAG, 'hideErrorOSD');
        Log.i(TAG, 'hideErrorOSD');
        dispatch(setIsErrorOSDActiveAction(false));
        dispatch(setErrorOSDAction('', '', 0));
    }
};

export const showErrorOSD =
    (code: string, message: string, priority: number) =>
    (dispatch: Function, getState: Function) => {
        const { isErrorOSDActive, errorPriority } = getState().errorOsd;

        if (!isErrorOSDActive || priority > errorPriority) {
            Diagnostics.info(
                TAG,
                'showErrorOSD code:',
                code,
                ' message:',
                message,
                ' priority:',
                priority,
            );
            Log.i(TAG, 'showErrorOSD code:', code, ' message:', message, ' priority:', priority);
            dispatch(setErrorOSDAction(code, message, priority));
            dispatch(setIsErrorOSDActiveAction(true));
        }
    };

export default osdReducer;
